var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login article-login", on: { click: _vm.goLogin } },
    [
      _c(
        "a",
        {
          staticClass: "login-sohu",
          attrs: { href: "javascript:void(0)", "data-role": "login-btn" },
        },
        [_vm._v("登录")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }